

































































































import { Component, Prop } from 'vue-property-decorator';
import Vue from 'vue';

import CardComponent from '@/modules/core/components/CardComponent.vue';
import DevicesTable from '@/modules/device/components/DevicesTable.vue';
import AlertsTable from '@/modules/alert/components/AlertsTable.vue';
import TechnicalMessagesTable from '@/modules/technical-message/components/TechnicalMessagesTable.vue';
import BreadcrumbsTable from '@/modules/breadcrumb/components/BreadcrumbsTable.vue';
import UserDeleteBtn from './UserDeleteBtn.vue';
import UserEditBtn from './UserEditBtn.vue';
import { RoleType } from '@shared/common/types';

@Component({
  components: {
    CardComponent,
    DevicesTable,
    AlertsTable,
    TechnicalMessagesTable,
    BreadcrumbsTable,
    UserEditBtn,
    UserDeleteBtn,
  },
})
export default class User extends Vue {
  public RoleType = RoleType;
  @Prop({
    default: null,
  })
  public initialUser: any;

  public get user(): any {
    return this.initialUser;
  }

  public get cardTitle(): string {
    return `${this.user.fullname}`;
  }

  public onEntityDeleted(): void {
    this.$goBack();
  }
}
